import {useSelector} from 'react-redux';


import {userSelectors} from '../../User';


/**
 * @return {object} Customer of the user
 */
function useCustomer() {

    return useSelector(userSelectors.getCustomer);
}


export default useCustomer;
